export const API = {
  siteRepo: {
    root: "/fc-site-repo",
    searchMqProjects: "/search/projects",
    getLayerByProject: "/search/{0}/layers",
    getImagesByFloor: "/search/picture/{0}/layers/{1}",
    accountLookup: "/search/accountInfo",
    createSite: "/create/site",
    searchSite: "/search/sites",
    getSite: "/site/{0}",
    getAllSiteNames: "/sites",
    deleteLayer: "/delete/floor",
    addLaborCodeToProduct: "/add/laborCode",
    deleteLaborCodeFromProduct: "/delete/laborCode",
    getLaborCodes: "/laborCodes",
    updateProduct: "/update/product",
    updateRoom: "/update/room",
    deleteProduct: "/delete/product",
    addProduct: "/add/product",
    createQuote: "/create/quote",
    getCutSheetsData: "/cutSheet/{0}",
    getProductCategory: "/categories/{0}",
    searchSitesForBulkUpdate: "/search/bulk/product",
    updateProductsInBulk: "/update/bulk/products/sites",
    getChangeLog: "/change/log/{0}",
    createUpdateCutsheetRollCutData: "/create/cutSheet/roll",
    deleteMeasurement: "/delete/rollcut",
    updateSiteProduct: "/update/bulk/products/site",
    rerunBulkUpdate: "/changelog/{0}",
  },
  searchProducts: "/fc-site-repo/search/product",
  isSchedulingToggle: "/fc-schedule/appProperties/{0}",
  laborTable: {
    root: "/fc-labor-table",
    districtList: "/districts",
    storeNumberList: "/storeNumbers",
    laborCodeList: "/laborCodes",
    statusList: "/status",
    searchSubmit: "/laborTable/details",
    updatePricing: "/update/billRate",
    approveRejectPricing: "/approveReject/billRate",
    verifyCurrentRates: "/verify",
    exceptionPrices: "/laborTable/laborCodeSearch",
    getPrices: "/laborCode/{0}/{1}",
    editprice: "/laborCode/update",
    deletePrice: "/laborCode/delete",
    addPrice: "/laborCode",
    showExpPrice: "/laborCode/{0}",
    getLaborPrices: "/laborPrice",
  },

  priceQuote: {
    root: "/fc-price-quote",
    createQuote: "/create/quote",
    addFloorPlan: "/create/floor",
    editQuote: "/update/quote",
    deleteFloorPlan: "/delete/floorplan",
    editFloorPlan: "/floor",
    floorPlanDetails: "/floorplan/details/{0}/{1}",
    floorDetailsSave: "/floorplan/store",
    accountLookup: "/search/accountInfo",
    laborCodeDelete: "/delete/labor",
    productDelete: "/delete/products",
    prc: "/prc",
    getPrice: "/get/price",
    savePdfOptions: "/store/pdf/options",
    getPdfOptions: "/get/pdf/options",
    email: "/mail",
    pdfData: "/download/pdf/{0}",
    searchQuote: "/search/quote",
    viewQuote: "/view/quote/{0}",
    laborCodes: "/laborCodes/{0}",
    emailNotification: "/get/emails/{0}",
    duplicateQuote: "/create/duplicate/quote",
    checkDuplicateName: "/check/quote?quoteName={0}",
    prodCategories: "/get/categories",
    bulkEditSearch: "/search/bulkedit/quote",
    bulkUpdateProducts: "/update/bulk/products",
    editFloorName: "/update/floor/name",
    taxVerify: "/tax/acknowledgement/{0}",
    laborSearch: "/search/laborCodes",
    bulkUpdateLabor: "/update/bulk/laborCodes",
    duplicateFloor: "/create/duplicate/floor",
    getBulkProductsData: "/quoteData",
    bulkUpdateQuote: "/update/prices/quote",
    createPRC: "/createPrcHdr",
    updatePRC: "/createTagPrcDtls",
    salesRep: "/salesRep/{0}/{1}",
  },
  programBuilder: {
    root: "/pb",
    categories: "/categories",
    products: "/products",
    laborCodes: "/laborCodes",
    createProgram: "/program",
    searchProgram: "/programs",
    productCategory: "/productCategory",
    lineItem: "/lineItem",
    getCategoriesList: "/program/{0}/productCategories",
    getLineItems: "/program/{0}/lineItems",
    getProgramDetails: "/program/{0}",
    getLineItemPrices: "/program/{0}/lineItemPrices",
    addLineItemPrices: "/lineItemPrice",
  },
  parentSearch: "/fc-sherlink/nationalParents",
};
